import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component contains Company branch and estimate information like "company branch logo",name,address etc.
    let Record = useContext(RecordsManagementContext)
    let IV1_PageDetails = Record.IV1_PageDetails
    let IV2_PageDetails = Record.IV2_PageDetails
    let EstimateAndCompanyInfoData = Record.CP_PageDetails.EstimateAndCompanyInfo
    let Estimate = EstimateAndCompanyInfoData.Estimate
    const estimateLabels = {guaranteed: "Binding Estimate", hourly: "Non-Binding Estimate", not_to_exceed: "Non-Binding Estimate", tariff_default: "Binding Estimate"};
    let CBandEstInfo = (IV1_PageDetails.bol_type === 'Texas BOL' || IV1_PageDetails.bol_type === "Default BOL") ? IV1_PageDetails.CompanyBranchAndEstimateInfo : IV2_PageDetails.CompanyBranchAndEstimateInfo
    return (
        <div className="row my-2">
            <table className="table">
                <tbody>
                <tr>
                    <td className="td-main-bost">
                        {CBandEstInfo.Quote}<br></br>
                        {CBandEstInfo.BookingNumber}<br></br>
                        {CBandEstInfo.ServiceDate}<br></br>
                        {CBandEstInfo.CBWebSite}
                        <p>{estimateLabels[Estimate.EstimateType] || ""}</p>
                    </td>
                    <td className="td-main-bost" style={{ textAlign: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: 250,
                                width: 300,
                                margin: "0 auto"
                            }}
                        >
                            <img
                                src={CBandEstInfo.CBLogo}
                                alt="Company Logo"
                                style={{
                                    maxWidth: "220%",
                                    maxHeight: "80%",
                                    objectFit: "contain"
                                }}
                            />
                        </div>
                    </td>
                    <td className="td-main-bost" style={{textAlign: "right"}}>
                        <b>{CBandEstInfo.CBName}</b><br/>
                        {CBandEstInfo.CBStreet}<br/>
                        {CBandEstInfo.CBSuiteNumber}<br/>
                        {CBandEstInfo.CBAddress}<br/>
                        {CBandEstInfo.StateAuthority}<br></br>
                        {CBandEstInfo.UsDot}<br></br>
                        {CBandEstInfo.CBPhnNmbr}<br/>
                        {CBandEstInfo.CBTollFreePhnNmbr}<br/>
                        {CBandEstInfo.CBFax}<br/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}